import { BlockRounded } from "@mui/icons-material";
import { ReactNode } from "react";

export const getDocumentsStatusIcon = (statusCode: number, color?: string): ReactNode => {
    if (statusCode === 605530007) {
        // To be uploaded
        return (
            <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7.33337 10.5H8.66671V6.49996H10.6667L8.00004 3.16663L5.33337 6.49996H7.33337V10.5Z"
                    fill={color || '#3987E2'}
                />
                <path
                    d="M13.3334 12.5H2.66671V7.83337H1.33337V12.5C1.33337 13.2354 1.93137 13.8334 2.66671 13.8334H13.3334C14.0687 13.8334 14.6667 13.2354 14.6667 12.5V7.83337H13.3334V12.5Z"
                    fill={color || '#3987E2'}
                />
            </svg>
        );
    } else if (statusCode === 1 || statusCode === 605530002) {
        // Active || Validated
        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke={color || 'green'}
                className="w-4 h-4"
            >
                <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M4.5 12.75l6 6 9-13.5"
                />
            </svg>
        );
    } else if (statusCode === 605530005 || statusCode === 605530006) {
        // Expired || Not Acceptable
        return (
            <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M7.99992 1.83325C4.31992 1.83325 1.33325 4.81992 1.33325 8.49992C1.33325 12.1799 4.31992 15.1666 7.99992 15.1666C11.6799 15.1666 14.6666 12.1799 14.6666 8.49992C14.6666 4.81992 11.6799 1.83325 7.99992 1.83325ZM2.66659 8.49992C2.66659 5.55325 5.05325 3.16659 7.99992 3.16659C9.23325 3.16659 10.3666 3.58659 11.2666 4.29325L3.79325 11.7666C3.0611 10.8353 2.66418 9.68451 2.66659 8.49992ZM7.99992 13.8333C6.76659 13.8333 5.63325 13.4133 4.73325 12.7066L12.2066 5.23325C12.9387 6.1645 13.3357 7.31533 13.3333 8.49992C13.3333 11.4466 10.9466 13.8333 7.99992 13.8333Z"
                    fill={color || '#CF0A2C'}
                />
            </svg>
        );
    } else if (statusCode === 605530001) {
        // To be evaluated
        return (
            <svg
                width="16"
                height="17"
                viewBox="0 0 16 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M12 1.83325H6.66663L2.67996 5.83325L2.66663 13.8333C2.66663 14.5666 3.26663 15.1666 3.99996 15.1666H12C12.7333 15.1666 13.3333 14.5666 13.3333 13.8333V3.16659C13.3333 2.43325 12.7333 1.83325 12 1.83325ZM12 13.8333H3.99996V6.38659L7.21996 3.16659H12V13.8333ZM7.33329 10.4999H8.66663V11.8333H7.33329V10.4999ZM7.33329 5.83325H8.66663V9.16659H7.33329V5.83325Z"
                    fill={color || '#3987E2'}
                />
            </svg>
        );
    }

    return <div></div>;
};


export const getMainServicesStatusIcon: (statusCode: number) => ReactNode = (statusCode) => {

    if (statusCode === 1 || statusCode === 605530005 || statusCode === 605530006) {
        // Active || Qualified || Contracted
        return (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} className="w-4 h-4 stroke-green">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
        )
    } else if (statusCode === 605530000 || statusCode === 2 || statusCode === 605530010 || statusCode === 605530011 || statusCode === 605530012 || statusCode === 605530013) {
        // Expired || Inactive || Expired(2) || Declined - outbound || Declined - inbound || Canceled
        return (
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.99992 1.83325C4.31992 1.83325 1.33325 4.81992 1.33325 8.49992C1.33325 12.1799 4.31992 15.1666 7.99992 15.1666C11.6799 15.1666 14.6666 12.1799 14.6666 8.49992C14.6666 4.81992 11.6799 1.83325 7.99992 1.83325ZM2.66659 8.49992C2.66659 5.55325 5.05325 3.16659 7.99992 3.16659C9.23325 3.16659 10.3666 3.58659 11.2666 4.29325L3.79325 11.7666C3.0611 10.8353 2.66418 9.68451 2.66659 8.49992ZM7.99992 13.8333C6.76659 13.8333 5.63325 13.4133 4.73325 12.7066L12.2066 5.23325C12.9387 6.1645 13.3357 7.31533 13.3333 8.49992C13.3333 11.4466 10.9466 13.8333 7.99992 13.8333Z" fill="#CF0A2C" />
            </svg>

        )
    } else if (statusCode === 605530003 || statusCode === 605530004) {
        // To be evaluated || To be qualified
        return (
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1.83325H6.66663L2.67996 5.83325L2.66663 13.8333C2.66663 14.5666 3.26663 15.1666 3.99996 15.1666H12C12.7333 15.1666 13.3333 14.5666 13.3333 13.8333V3.16659C13.3333 2.43325 12.7333 1.83325 12 1.83325ZM12 13.8333H3.99996V6.38659L7.21996 3.16659H12V13.8333ZM7.33329 10.4999H8.66663V11.8333H7.33329V10.4999ZM7.33329 5.83325H8.66663V9.16659H7.33329V5.83325Z" fill="#3987E2" />
            </svg>
        )
    } else if ( statusCode === 105810001 ){
        return(
            <BlockRounded sx={{color:'#CF0A2C',fontSize:'16px'}}/>
        )
    }

    return (
        <div></div>
    )
}

export const getAdditionalServicesStatusIcon: (statusCode: number) => ReactNode = (statusCode) => {

    if (statusCode === 1 || statusCode === 605530003 || statusCode === 605530004) {
        // Active || Qualified || Contracted
        return (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} className="w-4 h-4 stroke-green">
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
        )
    } else if (statusCode === 605530000 || statusCode === 2 || statusCode === 605530007 || statusCode === 605530005 || statusCode === 605530006 || statusCode === 605530008) {
        // Expired || Inactive || Expired(2) || Declined - outbound || Declined - inbound || Canceled
        return (
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.99992 1.83325C4.31992 1.83325 1.33325 4.81992 1.33325 8.49992C1.33325 12.1799 4.31992 15.1666 7.99992 15.1666C11.6799 15.1666 14.6666 12.1799 14.6666 8.49992C14.6666 4.81992 11.6799 1.83325 7.99992 1.83325ZM2.66659 8.49992C2.66659 5.55325 5.05325 3.16659 7.99992 3.16659C9.23325 3.16659 10.3666 3.58659 11.2666 4.29325L3.79325 11.7666C3.0611 10.8353 2.66418 9.68451 2.66659 8.49992ZM7.99992 13.8333C6.76659 13.8333 5.63325 13.4133 4.73325 12.7066L12.2066 5.23325C12.9387 6.1645 13.3357 7.31533 13.3333 8.49992C13.3333 11.4466 10.9466 13.8333 7.99992 13.8333Z" fill="#CF0A2C" />
            </svg>

        )
    } else if (statusCode === 605530001 || statusCode === 605530002) {
        // To be evaluated || To be qualified
        return (
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 1.83325H6.66663L2.67996 5.83325L2.66663 13.8333C2.66663 14.5666 3.26663 15.1666 3.99996 15.1666H12C12.7333 15.1666 13.3333 14.5666 13.3333 13.8333V3.16659C13.3333 2.43325 12.7333 1.83325 12 1.83325ZM12 13.8333H3.99996V6.38659L7.21996 3.16659H12V13.8333ZM7.33329 10.4999H8.66663V11.8333H7.33329V10.4999ZM7.33329 5.83325H8.66663V9.16659H7.33329V5.83325Z" fill="#3987E2" />
            </svg>
        )
    }else if ( statusCode === 105810001 ){
        return(
            <BlockRounded sx={{color:'#CF0A2C',fontSize:'16px'}}/>
        )
    }

    return (
        <div></div>
    )
}

export const getContractsStatusIcon: (statusCode: number, color?: string) => ReactNode = (statusCode, color) => {

    if (statusCode === 605530003 || statusCode === 0) {
        // Active 
        return (
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} className={`w-4 h-4 ${color ? `stroke-${color}` : "stroke-green"}`}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M4.5 12.75l6 6 9-13.5" />
            </svg>
        )
    } else if (statusCode === 605530002) {
        // To be signed
        return (
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className={`w-4 h-4 ${color ? `fill-${color}` : 'fill-[#EABD11]'}`}
            >
                <path d="M8.00004 1.33325C4.32404 1.33325 1.33337 4.32392 1.33337 7.99992C1.33337 11.6759 4.32404 14.6666 8.00004 14.6666C11.676 14.6666 14.6667 11.6759 14.6667 7.99992C14.6667 4.32392 11.676 1.33325 8.00004 1.33325ZM8.00004 13.3333C5.05937 13.3333 2.66671 10.9406 2.66671 7.99992C2.66671 5.05925 5.05937 2.66659 8.00004 2.66659C10.9407 2.66659 13.3334 5.05925 13.3334 7.99992C13.3334 10.9406 10.9407 13.3333 8.00004 13.3333Z" />
                <path d="M8.66671 4.66675H7.33337V8.27608L9.52871 10.4714L10.4714 9.52875L8.66671 7.72408V4.66675Z" />
            </svg>
        )
    }

    return (
        <div></div>
    )
}